import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {ORDER_DOCS} from '@/framework/static/filter-attribute-code-value-type';
import {HomepageFeaturedBlock} from '__generated__/__types__';
import Link from 'next/link';

const ProductAttributesSwiper = ({
    data,
    attributeIndex,
    canonicalUrl,
    isQuantitativeAttribute = false,
}: {
    data: HomepageFeaturedBlock;
    attributeIndex: number;
    canonicalUrl: string;
    isQuantitativeAttribute?: boolean;
}) => {
    const attribute = data?.product_attributes?.[attributeIndex];
    const slidesPerView = isQuantitativeAttribute ? 5 : 4;
    const spaceBetween = isQuantitativeAttribute ? 12 : 0;

    if (!data?.product_attributes?.length) {
        return <></>;
    }

    return (
        <div className="border-b pb-5 lg:border-b-0 lg:border-r lg:pb-0">
            <Swiper loop={true} slidesPerView={slidesPerView} spaceBetween={spaceBetween}>
                {attribute?.options
                    ?.filter(item => item?.value !== ORDER_DOCS)
                    ?.map(item => (
                        <SwiperSlide key={item?.label} className="border-r border-KPZ_Gray_05 last:border-r-0">
                            <Link
                                href={`${canonicalUrl}?${attribute?.attribute_code}=${item?.label}`}
                                className="flex items-center justify-center text-center text-xs text-black transition-colors hover:text-KPZ_Orange-30 md:text-base">
                                {item?.value}
                            </Link>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
};

export default ProductAttributesSwiper;
